// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C7p4RKB73_CaqF53xdzw .QTk_K0caP_B2IND4hfM8{padding:11px 8px 11px 11px}.C7p4RKB73_CaqF53xdzw .U4WHan_PyLvcK2ZrbPaY{margin-left:4px;padding:0;font-size:13px}.Sm99uiRVEoX1SlB3A633{margin-right:10px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/CommonNumbers/styles.module.scss"],"names":[],"mappings":"AACE,4CACE,0BAAA,CAGF,4CACE,eAAA,CACA,SAAA,CACA,cAAA,CAGJ,sBACE,iBAAA","sourcesContent":[".wrap {\n  .select {\n    padding: 11px 8px 11px 11px;\n  }\n\n  .link {\n    margin-left: 4px;\n    padding: 0;\n    font-size: 13px;\n  }\n}\n.labelText {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `C7p4RKB73_CaqF53xdzw`,
	"select": `QTk_K0caP_B2IND4hfM8`,
	"link": `U4WHan_PyLvcK2ZrbPaY`,
	"labelText": `Sm99uiRVEoX1SlB3A633`
};
export default ___CSS_LOADER_EXPORT___;
